"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");









































































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = { name: 'Intention', props: { intent: { type: Object, default: function _default() {return { id: '', intentCode: '', standardSlot: '' };} }, value: Number }, data: function data() {return { handleShow: false, tableData: [], // 列表数据
      id: '', searchData: { intentCode: '', standardSlot: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'intentCode', label: '编码', isShow: true }, { prop: 'standardSlot', label: '词槽', isShow: true }, { prop: 'remark', label: '描述', isShow: true }] };}, watch: { value: function value(oldV, newV) {// 监听父组件的变化
      this.id = oldV;} }, mounted: function mounted() {var self = this;console.log('id', self.id);self.init();}, methods: { init: function init() {var self = this;self.getData('/api/voiceIntent', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.standardSlot = '';this.searchData.intentCode = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleClose: function handleClose() {
      this.handleShow = false;
    },
    handleCheckRow: function handleCheckRow(row) {
      var self = this;
      // self.value = row.id
      self.intent.id = row.id;
      self.intent.intentCode = row.intentCode;
      self.intent.standardSlot = row.standardSlot;
      self.intent.slot = row.slot;
      // this.$emit('getCheckEvent', event)
    },
    sendMsgToParent: function sendMsgToParent() {
      var self = this;
      self.$emit('sendMsgToParent', self.intent);
      self.handleShow = false;
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    closeDiglog: function closeDiglog() {
      this.handleShow = false;
    } } };exports.default = _default2;